import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 100%;
    padding: ${theme.layout.chat_header_height} 16px
      ${theme.layout.chat_navigation_height};
  `}
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
  height: 100%;
`;

export const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;

  img {
    display: block;
    width: auto;
    max-width: 100%;
    max-height: 275px;
  }
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    text-align: center;

    strong {
      display: block;
      width: 100%;
      ${theme.fontStyle.poppins.title}
      color: ${theme.content.content_light_1};
    }

    p {
      display: block;
      width: 100%;
      color: ${theme.content.content_light_3};
      ${theme.fontStyle.poppins.desc}
    }
  `}
`;

export const ButtonBox = styled.div`
  display: block;
  position: fixed;
  bottom: 32px;
  left: 50%;
  width: 100%;
  padding: 0 16px;
  transform: translateX(-50%);
`;
